import { render, staticRenderFns } from "./RoleRowItem.vue?vue&type=template&id=080272a6&scoped=true&"
import script from "./RoleRowItem.vue?vue&type=script&lang=js&"
export * from "./RoleRowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080272a6",
  null
  
)

export default component.exports